import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";

export default class APIMedia extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getMessageId = async (
    messageId: UUID,
    { originalFilename }: { originalFilename: string },
  ): Promise<Response> => {
    let res = await this._fetch({
      url: `/messages/media/${messageId}`,
      method: "GET",
      params: { original_filename: originalFilename },
    });
    return res;
  };
}
